import { observer } from 'mobx-react';
import { defaultTemplate } from 'core/hoc';
import { BaasicDropdownOptionOverride } from 'core/components';
import { isSome } from 'core/utils';
import Select from 'react-select';
import React from 'react';
import _ from 'lodash';

const BaasicDropdownTemplate = ({
	t,
	dropdownStore,
	isClearable,
	placeholder,
	className,
	classNamePrefix,
	menuPlacement,
	label,
	autoFocus,
	additionalLabel,
	isDisabled,
	menuIsOpen,
	isSearchable,
}) => {
	const {
		value,
		options,
		isLoading,
		onMenuScrollToBottom,
		onChange,
		onInputChange,
		field,
		optionOverride,
		isRequired,
		onBlur,
		onMenuClose,
		isMulti,
	} = dropdownStore;
	return (
		<div className="react-select-override">
			<Label {...{ t, field, label, isRequired, additionalLabel }} />
			{field != null && <FieldError {...{ t, field }} />}
			<Select
				components={
					optionOverride != null
						? { Option: props => <BaasicDropdownOptionOverride {...props} {...optionOverride} /> }
						: null
				}
				{...{
					isMulti,
					autoFocus,
					isClearable,
					placeholder,
					value,
					options,
					isDisabled,
					isLoading,
					onMenuScrollToBottom,
					onChange,
					onInputChange,
					onBlur,
					onMenuClose,
					className,
					classNamePrefix,
					menuPlacement,
					menuIsOpen,
					isSearchable,
				}}
			/>
		</div>
	);
};

const Label = observer(({ field, t, label, isRequired, additionalLabel }) => {
	return (
		<div className="form__group__header">
			<label htmlFor={field != null ? field.id : null} id={field != null ? field.name + '-label' : null}>
				{t(field != null ? field.label : label)}{' '}
				{(field != null && field.rules && field.rules.includes('required')) || isRequired ? (
					<span className="type--color--warning">*</span>
				) : null}
			</label>
			{additionalLabel && additionalLabel()}
		</div>
	);
});

const FieldError = observer(({ t, field }) => {
	if (isSome(field.error)) return <p className="type--tny type--color--error spc--bottom--tny">{t(field.error)}</p>;
});

export default defaultTemplate(BaasicDropdownTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/components/select/BaasicDropdownTemplate.jsx